/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-us';
import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Loading from 'quasar/src/plugins/Loading.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';import Cookies from 'quasar/src/plugins/Cookies.js';import Meta from 'quasar/src/plugins/Meta.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';;
Vue.use(Quasar, {
  config: {
    "loadingBar": {
      "skip-hijack": true
    }
  },
  lang: lang,
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup
  },
  plugins: {
    Loading: Loading,
    Dialog: Dialog,
    Notify: Notify,
    Cookies: Cookies,
    Meta: Meta,
    LoadingBar: LoadingBar
  }
});